import React, { useCallback, useState } from "react";
import { Popover } from "../../components";

export const unitTypes = [{
  id: 'metric', displayName: 'Metric Units'
}, {
  id: 'imperial', displayName: 'Imperial Units'
}]

export const UnitsPopover = ({ history }) => {

  const defaultUnit = unitTypes.find(unitData => unitData.id === (localStorage.getItem('unit') || 'metric'))
  const [selectedUnit, setSelectedUnit] = useState(defaultUnit)

  const onSelectUnit = useCallback(unitData => {
    if (selectedUnit.id !== unitData.id) {
      setSelectedUnit(unitData)
      localStorage.setItem("unit", unitData.id);
      history.go(0)
    }
  }, [selectedUnit, history])

  return (
    <Popover
      content={<UnitsPopoverContent onSelectUnit={onSelectUnit} selectedUnit={selectedUnit.id} />}
      placement="bottom"
      className='units-popover'
    >
      <div className="unit-container">
        <img className="unit-icon" alt="unit" src={`/images/icon/${selectedUnit.id}-unit.svg`} /> <span className="unit-name">{selectedUnit.displayName}</span>
      </div>
    </Popover>
  )
}

export const UnitsPopoverContent = ({ selectedUnit, onSelectUnit }) => {
  return (
    <div className="units-list-container">
      {unitTypes.map(unitData => <div className={`single-unit-container ${selectedUnit === unitData.id ? 'selected-unit' : ''}`} key={unitData.id} onClick={() => onSelectUnit && onSelectUnit(unitData)}><img className="unit-icon" alt="unit" src={`/images/icon/${unitData.id}-unit.svg`} /> <span className="unit-name">{unitData.displayName}</span></div>)}
    </div>
  )
}

export default UnitsPopover
